import Vue from 'vue'
import Router from 'vue-router'
import {isAndroid,isIOS} from './utils/env'
Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => {return (!isAndroid && !isIOS ) ? import('./views/web.vue') : import('./views/h5.vue')}
    },
    {
      path: '/vipagree',
      name: 'vipAgree',
      component: () => import('./views/vipAgree.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/privacy.vue')
    },
    {
      path: '/useragree',
      name: 'useragree',
      component: () => import('./views/userAgree.vue')
    },
    {
      path: '/problem',
      name: 'problem',
      component: () => import('./views/problem.vue')
    },
    {
      path : "/problem/detail/:id",
      name : "problemDetail",
      component: () => import('./views/problemDetail.vue'),
    },
    {
      path : "/share",
      name : "share",
      component: () => import('./views/share.vue'),
    },
    {
      path : "/getvip",
      name : "GetVip",
      component: () => import('./views/getvip.vue'),
    },
    {
      path : "/auth/:brand?",
      name : "Auth",
      component: () => import('./views/auth_brand.vue'),
    },
    {
      path : "*",
      name : "404",
      component: () => import('./views/404.vue'),
    }
  ]
})
